export function userSlugFromAnchor(anchor) {
  let userSlug = anchor.dataset.href || anchor.pathname,
    // matches either location.href= or open()
    onclickRegex = /(?:location.href=|open\()['"](?<userslug>\/users\/.+?)['"]/i
  if (!userSlug || userSlug.includes('void(0)')) {
    userSlug = anchor.onclick.toString().match(onclickRegex).groups.userslug;
  }
  return userSlug;
}

export function userTaggingMarkup(userSlug, userName) {
  return `<a contenteditable="false" href="javascript:void(0)" data-href='${userSlug}'
                          target="_blank" data-gitb-tagged="true">@${userName}</a>`;
}